import React from 'react';

export const appWrapper = (Component: React.FC, id: string) =>
  function HOC() {
    return (
      <div id={id}>
        <Component />
      </div>
    );
  };
